import { WABUNKA_ALL_AREA_TAG } from '@/wabunka-src/constants/wabunkaSearch';

export const generateSearchPath = (destinations: string | undefined, themes: string | undefined, dates: string | undefined, timeOfDay: string | undefined, preferences?: string) => {
  const destinationsSplit = destinations ? destinations.split(',') : [];
  const themesSplit = themes ? themes.split(',') : [];
  const SEARCH_BASE_PATH = '/s/experiences/';

  let navigateToPath = SEARCH_BASE_PATH;
  const destCount = destinationsSplit.length;
  const themeCount = themesSplit.length;
  const hasDates = !!dates;
  const hasPreferences = !!preferences;
  const hasTimeOfDay = !!timeOfDay;
  // 日付・preferences・時間帯のいずれかが指定されている場合は、Index されるエリア/テーマページではなく
  // フィルタが効く No-Index の検索結果ページへ遷移させる
  const hasFilter = hasDates || hasPreferences || hasTimeOfDay;

  switch (true) {
    case destCount === 0 && themeCount === 1 && !hasFilter:
      // destination 0, theme 1, フィルタなし: カテゴリページ（Japan）に遷移
      navigateToPath = `/japan/${themesSplit[0]}/`;
      break;

    case destCount === 0 && themeCount === 1 && hasFilter:
      // destination 0, theme 1, フィルタあり: 検索結果ページ（プレースホルダーとしてall-areaを入れる）
      navigateToPath = `${SEARCH_BASE_PATH}${WABUNKA_ALL_AREA_TAG}/${themesSplit[0]}/`;
      break;

    case destCount === 1 && themeCount === 0 && !hasFilter:
      // destination 1, theme 0, フィルタなし: エリアページに遷移
      navigateToPath = `/${destinationsSplit[0]}/`;
      break;

    case destCount === 1 && themeCount === 0 && hasFilter:
      // destination 1, theme 0, フィルタあり: 検索結果ページ
      navigateToPath = `${SEARCH_BASE_PATH}${destinationsSplit[0]}/`;
      break;

    case destCount === 1 && themeCount === 1 && !hasFilter:
      // destination 1, theme 1, フィルタなし: DestinationThemeページに遷移
      navigateToPath = `/${destinations}/${themesSplit[0]}/`;
      break;

    case destCount === 1 && themeCount === 1 && hasFilter:
      // destination 1, theme 1, フィルタあり: 検索結果ページ
      navigateToPath = `${SEARCH_BASE_PATH}${destinations}/${themesSplit[0]}/`;
      break;

    default:
      // その他の場合はデフォルトの検索結果ページ
      navigateToPath = SEARCH_BASE_PATH;
  }

  const shouldContainConditionAsQueryParam = destCount > 1 || themeCount > 1;
  const shouldContainDestinationInQueryParam = shouldContainConditionAsQueryParam && destCount > 0;
  const shouldContainThemeInQueryParam = shouldContainConditionAsQueryParam && themeCount > 0;

  return {
    path: navigateToPath,
    query: {
      destinations: shouldContainDestinationInQueryParam ? destinations : undefined,
      themes: shouldContainThemeInQueryParam ? themes : undefined,
      preferences: preferences || undefined,
      experienceEventStartAtDates: dates || undefined,
      timeOfDay: timeOfDay || undefined,
    },
  };
};

export type SearchPathQuery = ReturnType<typeof generateSearchPath>;
